// extracted by mini-css-extract-plugin
export default {"alignButton":"SourceAccountView_alignButton__ZhFrJ"};